import React from 'react';
import { PageSection, Title } from 'common/styles/page';
import TeamPillarScores from './TeamPillarScores';
import DashboardCard from 'areas/dashboard/components/DashboardCard';
import TeamInsights from './TeamInsights';

import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getMostRecentAssessmentPeriodId } from 'common/selectors/auth';

interface TeamProjectHeaderProps {
  team_id?: number;
}

const Half = styled.div`
  flex: 1 1 0%;
  min-width: 0;
  display: flex;
  align-items: stretch;
  padding: 0;
`;

const Divider = styled.div`
  width: 1px;
  background: #e5e7eb; /* light grey */
  margin: 0 40px; 
  align-self: stretch;
`;

const TeamProjectHeader: React.FC<TeamProjectHeaderProps> = ({ team_id }) => {
  const assessmentPeriodId = useSelector(getMostRecentAssessmentPeriodId);

  return (
    <DashboardCard>
      <PageSection display='flex' flexDirection='row' flex='2'>

        <Half>
          <TeamInsights team_id={team_id ?? 0} />
        </Half>
        <Divider />
        <Half>
          <TeamPillarScores
            teamId={team_id ?? 0}
            assessment_period_id={assessmentPeriodId}
          />
        </Half>
      </PageSection>
    </DashboardCard>
  );
};
export default TeamProjectHeader;

